export enum ValuationStatusEnum {
  IN_PROGRESS = "IN_PROGRESS",
  CLOSED = "CLOSED",
}

export const getValuationStatusLabel = (status: ValuationStatusEnum): string => {
  switch (status) {
    case ValuationStatusEnum.IN_PROGRESS:
      return "En curso";
    case ValuationStatusEnum.CLOSED:
      return "Cerrado";
  }
};

export const getValuationStatusOptions = (): { label: string; value: string }[] => {
  return Object.values(ValuationStatusEnum).map((value) => ({
    label: getValuationStatusLabel(value),
    value,
  }));
};
